import { useState, useContext, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";

import UserForm from "./UserForm";
import Userprofile from "./Userprofile";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
import moment from "moment";
import { useParams } from "react-router-dom";
import { UserContext } from "../../common";

import MessageModal from "../../components/MessageModal";

const Users = (props) => {
  const { userData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [mode, setMode] = useState(0);
  const [selectedUser, setSelectedUser] = useState(0);
  const [filter, setFilter] = useState({ start: 0, limit: 10 });
  const [message, setMessage] = useState(false);
  const [txt,setTxt] = useState('');

  const fetchUsers = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchusers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUsers(_.get(res, "data.users", []));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchUsers, []);

  const afterUserSave = () => {
    setMessage({ type: "success", message: "User has been saved successfully!" });
    setMode(0);
    setSelectedUser(false);
    fetchUsers();
  };

  const toggleData = (e, d) => {
    console.log(d);
    if (window.confirm(`Do you want to ${d.is_active == "1" ? "de" : ""}activate this user?`)) {
      axios
        .post(Utils.apiUrl("users/toggleuser"), `id=${d.id}`, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchUsers();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  const handleDelete = (e, d) => {
    if (window.confirm(`You are going to delete this user, continue?`)) {
      axios
        .delete(Utils.apiUrl(`users/deleteuser/${d.id}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchUsers();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  if (!_.get(userData, "is_super_user", false)) {
    return (
      <>
        <h1 class="alert alert-danger p-5 mt-5">No access!</h1>
      </>
    );
  }
  
  const sortedUsers = _.orderBy(
    users,
    [
      (u) => (u.is_active === 1 || u.is_active === "1" || u.is_active === true ? 1 : 0),
      (u) => parseInt(u.id) || 0,
    ],
    ["desc", "desc"]
  );

  const planLimit = parseInt(_.get(userData, "plan.users", 0)) || sortedUsers.length;
  const planUsers = sortedUsers.slice(0, planLimit);

  const filteredUsers = planUsers.filter((u) => {
    const fullName = `${u.title || ""} ${u.firstname || ""} ${u.middlename || ""} ${u.lastname || ""}`.toLowerCase();
    const designation = (u.designation || "").toLowerCase();
    const query = (txt || "").toLowerCase().trim();
    return fullName.includes(query) || designation.includes(query);
  });

  return (
    <>
   
      <Row className="px-2 mt-2 mb-3">
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/users`} className="w-100 btn btn-primary py-2 fw-bold">
            Manage Users
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/roles`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Roles
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/helpmat`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Help Materials
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/userDocument`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Staff Documents
          </a>
        </Col>
      </Row>

      <div className="p-3 bg-white">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Users</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!loading && (
          <>
            {mode === 3 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>User's Profile</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="secondary" onClick={() => setMode(0)}>
                      Back
                    </Button>
                  </Col>
                </Row>
                <Userprofile data={selectedUser} />
              </>
            )}
            {(mode === 1 || mode === 2) && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>{["", "Add", "Edit"][mode]} User</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="secondary" onClick={() => setMode(0)}>
                      Back
                    </Button>
                  </Col>
                </Row>
                <UserForm mode={mode} onAdd={afterUserSave} data={selectedUser} />
              </>
            )}
            {mode === 0 && (
              <>
                <Row>
                  <Col xs='12' sm='4' md='4' >
                    <h2>Manage Users</h2>
                  </Col>
                  <Col className=" mt-2 mb-2 " xs='12' sm='4' md='3'>
                    <input
                      type="text"
                      placeholder="Search"
                      value={txt}
                      onChange={(e) => setTxt(e.target.value)}
                    />
                  </Col>
                  
                  <Col xs='6' md='3' sm='2' className="text-end">
                  <a href={`${process.env.PUBLIC_URL}/userdocument`}><Button className="ms-2" variant="primary" onClick={() => setMode(4)}>
                      HR Document Dashboard
                    </Button></a>
                  </Col >
                  <Col xs='6' md='2' sm='2' className="text-end">
                    {_.get(users,'length',0) <= parseInt(_.get(userData,'plan.users',0)) && <Button variant="success" className="ms-2" onClick={() => setMode(1)}>
                      Add +
                    </Button>}
                  </Col>
                </Row>
                <Row>
                  
                </Row>

                {users.length === 0 && <div className="alert alert-info p-5 text-center">No Users added yet!</div>}

                {users.length > 0 && (
                  <Table striped={true}>
                    <thead>
                      <tr>
                        <th className="d-none d-sm-table-cell" style={{ width: "40px" }}>
                          Sl.
                        </th>
                        <th >Name</th>
                        <th style={{ maxWidth: "50%" }} className="d-none d-sm-table-cell">Designation</th>
                        <th className="d-none d-sm-table-cell" style={{ width: "100px" }}>
                          Joined on
                        </th>
                        <th className="text-end">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((u, idx) => (
                        <tr>
                          <td className="d-none d-sm-table-cell">{filter.start + idx + 1}</td>
                          <td >
                            {u.title} {u.firstname} {u.middlename} {u.lastname}
                          </td>
                          <td style={{ maxWidth: "50%" }} className="d-none d-sm-table-cell">{u.designation}</td>
                          <td className="d-none d-sm-table-cell">{u.joining_date}</td>
                          <td>
                            <div className="d-flex justify-content-end">
                              <div className="form-check form-switch clickable" title={`Click to ${u.is_active === "1" ? "Disable" : "Enable"}`}>
                                <input
                                  onClick={(e) => toggleData(e, u)}
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  defaultChecked={u.is_active == "1"}
                                />
                              </div>
                              <img
                                width="22"
                                src={`${process.env.PUBLIC_URL}/images/myprofile.png`}
                                className="p-0 me-1 clickable"
                                title="View User's Profile"
                                onClick={() => {
                                  setSelectedUser(u);
                                  setMode(3);
                                }}
                              />
                              <img
                                width="22"
                                src={`${process.env.PUBLIC_URL}/images/edit.png`}
                                className="p-1 me-1 clickable"
                                title="Edit User"
                                onClick={() => {
                                  setSelectedUser(u);
                                  setMode(2);
                                }}
                              />
                              {u.hasJobs === "0" && (
                                <img
                                  width="20"
                                  src={`${process.env.PUBLIC_URL}/images/delete.png`}
                                  className="p-1 clickable"
                                  onClick={(e) => handleDelete(e, u)}
                                  title="Delete User"
                                />
                              )}
                              {u.hasJobs !== "0" && (
                                <img width="20" src={`${process.env.PUBLIC_URL}/images/delete-d.png`} className="p-1" title="User has jobs" />
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </>
            )}
          </>
        )}
      </div>

      {message && (
        <MessageModal
          type={message.type}
          message={message.message}
          onHide={() => {
            setMessage(false);
          }}
        />
      )}
    </>
  );
};

export default Users;
